<template>
  <div class="content">
    <div class="row animated fadeIn">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body mt-0 pt-0">
            <div class="row">
              <div class="col-md-6">
                <h4 class="card-title mb-3">
                  Send Message to User
                </h4>
                <multi-select
                    id="smart-search"
                    v-model="selectedUser"
                    label="name"
                    track-by="id"
                    placeholder="Search User"
                    :options="searchList"
                    :multiple="false"
                    :searchable="true"
                    :loading="isLoading"
                    :internal-search="false"
                    :clear-on-select="false"
                    :close-on-select="true"
                    :options-limit="300"
                    :max-height="600"
                    group-values="data"
                    group-label="type"
                    :group-select="false"
                    :show-no-results="true"
                    @search-change="getSearchList">
                  <template  slot="option" slot-scope="props">
                    <span v-if="props.option.$groupLabel" v-html="getHtmlForSearch(props.option.$groupLabel)" />
                    <span v-else>{{ props.option.name }}</span>
                  </template>
                  <span slot="noResult">Oops, nothing found.</span>
                </multi-select>
                <div class="form-group mt-5">
                  Name:
                  <input type="text" disabled v-model="name" class="form-control">
                </div>
                <div class="form-group">
                  To:
                  <input type="text" v-model="phone" class="form-control" placeholder="+11234456789">
                </div>
                <div class="form-group">
                  Message:
                  <textarea class="form-control" :disabled="!selectedUser && !phone" v-model="message" rows="5"></textarea>
                </div>
                <button type="submit" :disabled="(!selectedUser && !phone) || !message" @click="sendMessage" class="btn btn-primary btn-round mb-3 pull-right" >
                  <div v-if="isLoading" class="loader small_loader pull-rightl" style="width: 25px;height:25px"></div>
                  <span v-else>Send</span>
                </button>
                <button type="button" :disabled="isLoading" @click="refreshData" class="btn btn-danger btn-round mb-3 pull-right" >
                  <span>Clear</span>
                </button>
              </div>
              <div class="col-md-6">
                <h4 class="card-title">
                  Presets
                </h4>
                <ul class="list-unstyled preset mt-3">
                  <li v-for="(macro, index) of presetMacros" :key="index" @click="useThisMacro(macro)">
                    <h6><span v-html="(macro.title)? macro.title : ''"></span></h6>
                    <span v-html="(macro.message) ? macro.message.split('\n')[0].substr(0,40).replace(/\n/g,'<br>') + '...' : macro.split('\n')[0].substr(0,40).replace(/\n/g,'<br>')"></span>
                  </li>
                </ul>
              </div>
            </div>
<!--            <hr class="mt-5">-->
          </div>
        </div>

        <div class="row mt-2 p-3" v-if="uid">
          <div class="col-md-12">
            <chat-history :uid="uid" :email="email" />
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import _, {map} from "lodash";
import multiSelect from "vue-multiselect";
import swal from "sweetalert2";
import {db} from "@/firebase/init";

export default {
  name: "chat",
  components: {
    multiSelect,
    chatHistory: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/Communications/chatHistory"
            ),
  },
  watch: {
    selectedUser(data) {
      if (data && data.id) {
        this.name= data.fullName || ''
        this.email= data.email
        this.uid= data.id
        this.phone = null
        this.fetchUserDetails(data)
      } else {
        this.name= null
        this.email= null
        this.uid= 'Others'
        this.phone=null
      }

    }
  },
  data() {
    return {
      selectedUser: null,
      searchList: [],
      isLoading: false,
      name: null,
      phone: null,
      message: null,
      email: null,
      uid: 'Others',
      presetMacros: [],
    }
  },
  mounted(){
    this.getPresetReplies()
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    async getPresetReplies(){
      this.presetMacros=[]
      let result=await db.collection("permissions")
          .doc("preset_macros_chat")
          .get();
      if(result.exists){
        this.presetMacros = result.data().replies;
      }
    },
    async useThisMacro (macro) {
      this.loading = true
      if(!this.selectedUser){
        swal({
          title: "Error!",
          text: "Please select the user first!",
          type: "error",
          confirmButtonText: "Try Again",
          confirmButtonColor: "#EE8057"
        })
        return false
      }
      let msg = (macro.message) ? macro.message : macro;
      msg = msg.replace(/{firstName}/g, this.selectedUser.firstName)
      msg = msg.replace(/{lastName}/g, this.selectedUser.lastName)
      msg = msg.replace(/{email}/g, this.selectedUser.email)
      msg = msg.replace(/{signature}/g, this.user.signature)
      this.message= msg
      this.loading = false
    },
    async fetchUserDetails(data) {
      try{
        // const userRef = await db.collection('users').doc(data.id.toString()).get();
        // if (userRef.exists && userRef.data().mobile_number) {
        //   this.phone = userRef.data().mobile_number
        // } else {
          let response = await this.$http.post("host-bill/get-client-details", {
            grant_type: "token",
            clientId: data.clientId
          });
          if(response.data.success)
            response =response.data.client
            await db.collection('users').doc(data.id.toString()).update({
              mobile_number: response.phonenumber
            });
            this.phone = response.phonenumber
          // }
        }
      catch (e) {
        console.log(e.toString())
      }
    },
    async checkPhoneNumber () {
      try {
        const ref = await db.collection('users').doc(this.selectedUser.id).get();
        console.log('checking phone numbers', ref.data())
        if(ref.exists) {
          let { mobile_number, chatNumbers } = ref.data();
          if (mobile_number !== this.phone) {
            let phone = this.phone.replace(/ /g, '');
            if(!chatNumbers) {
              chatNumbers = [];
              chatNumbers.push(phone);
            } else if (chatNumbers && !chatNumbers.includes(phone)) {
              chatNumbers.push(phone);
            }
            console.log('inside condition')
            await db.collection('users').doc(this.selectedUser.id).update({chatNumbers})
          }
        }
      }
      catch (e) {
        console.log('error from checking phone number', e.toString());
      }
    },
    refreshData () {
      this.message=null
      this.phone=null
      this.email=null
      this.name=null
      this.uid='Others'
      this.selectedUser= null
    },
    async sendMessage(){
      try{
        this.isLoading = true
        if (this.selectedUser) {
          await this.checkPhoneNumber();
        }
        const response = await this.$http.post("twilio/send-message", {
          grant_type: "token",
          to: this.phone,
          uid: this.uid || 'Others',
          message: this.message,
          username: this.name || this.phone,
          email: this.email || this.phone,
          sender: this.user.firstName + ' ' + this.user.lastName
        });
        console.log(response)
        this.isLoading=false
        this.message=null
        // this.phone=null
        // this.email=null
        // this.name=null
        // this.selectedUser= null
        swal({
          title: "Success!",
          text: "Message has been sent successfully!",
          type: "success"
        })
      }catch (e) {
        this.isLoading=false
        this.message=null
        // this.phone=null
        // this.email=null
        // this.name=null
        // this.selectedUser= null
        swal({
          title: "Error!",
          text: "Something went wrong while sending message.",
          type: "error",
          confirmButtonText: "Try Again",
          confirmButtonColor: "#EE8057"
        })
      }
    },
      async getSearchList(query) {
      if (query.length > 0) {
        this.isLoading = true;
        let customers = [];
        let collaborators = [];
        let accounts = [];
        let domains = [];
        const searchRef = await this.$http.post("algolia/search", {
          grant_type: "token",
          query
        });
        let customersObjects = _.groupBy(searchRef.data, function(item) {
          // console.log(item)
          return item.uid
        })
        _.forEach(customersObjects, function(arrr, key) {
          if (arrr[0].customerID === '-1') {
            collaborators.push({
              id: key,
              name: `${arrr[0].firstName} ${arrr[0].lastName} ${arrr[0].email}`,
              fullName: `${arrr[0].firstName} ${arrr[0].lastName}`,
              clientId: arrr[0].customerID,
              email: arrr[0].email,
              firstName: arrr[0].firstName,
              lastName: arrr[0].lastName,
            })
          } else {
            customers.push({
              id: key,
              name: `#${arrr[0].customerID} ${arrr[0].firstName} ${arrr[0].lastName} ${arrr[0].email}`,
              fullName: `${arrr[0].firstName} ${arrr[0].lastName}`,
              clientId: arrr[0].customerID,
              email: arrr[0].email,
              firstName: arrr[0].firstName,
              lastName: arrr[0].lastName,
            })
          }
        })
        map(searchRef.data, (item) => {
          if (item.domain) {
            let accountDetail = {
              id: item.uid,
              name: `${item.domain} u: ${item.firstName} ${item.lastName} ip: ${item.serverIP}`,
              clientId: item.customerID,
              fullName: `${item.firstName} ${item.lastName}`,
              email: item.email,
              firstName: item.firstName,
              lastName: item.lastName,
            };
            let domain = {
              id: item.uid,
              name: `${item.domain}`,
              clientId: item.customerID,
              email: item.email,
              fullName: `${item.firstName} ${item.lastName}`,
              firstName: item.firstName,
              lastName: item.lastName,
            };
            accounts.push(accountDetail)
            domains.push(domain)
          }
        });
        this.searchList = [
          {
            type: 'Customers',
            icon: '<i class="fa fa-user"></i>',
            data: customers
          },
          {
            type: 'Collaborators',
            icon: '<i class="fa fa-user"></i>',
            data: collaborators
          },
          {
            type: 'Accounts',
            icon: '<i class="fa fa-cloud"></i>',
            data: accounts
          },
          {
            type: 'Domains',
            icon: '<i class="fa fa-globe"></i>',
            data: domains
          },
        ];
        this.isLoading = false;

      } else {
        this.searchList = [];
      }
    },
    getHtmlForSearch (label) {
      switch (label) {
        case 'Customers':
          return '<i class="fa fa-users mr-5" /> <span>Customers</span>'
        case 'Collaborators':
          return '<i class="fa fa-users mr-5" /> <span>Collaborators</span>'
        case 'Accounts':
          return '<i class="fa fa-cloud mr-5" /> <span>Accounts</span>'
        case 'Domains':
          return '<i class="fa fa-globe mr-5" /> <span>Domains</span>'
      }
    },

  }
}
</script>

<style lang="scss" scoped>
.preset {
  height: 470px;
  overflow: auto;
  li {
    cursor: pointer;
    border: 1px solid rgba(0,0,0,0.3);
    padding: 2px;
    background-color: rgba(0,0,0,0.1);
    border-radius: 3px;
    margin: 2px 0;
  }
}
</style>
